
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';

const token = localStorage.getItem('token');

const ModalExcluirServico = (props) => {

    const handleClose = () => {
        props.setOpenModalExcluirServico(false);
    };

    const handleAgree = async () => {
        await axios.delete(`${process.env.REACT_APP_API_URL}/excluirServico/${props.idServico}`, {
            headers: {
                Authorization: token
            }
        });
        props.setOpenModalExcluirServico(false);
    }
    return (
        <React.Fragment>
            <Dialog
                open={props.openModalExcluirServico}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Deseja realmente excluir este serviço?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Tem certeza de que deseja excluir este serviço? Esta ação não pode ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{display: 'flex', justifyContent: 'space-between', px: 3, pb: 2}}>
                    <Button onClick={handleClose} variant='contained' color='success' size='small'>Manter Serviço</Button>
                    <Button onClick={handleAgree}  autoFocus color='error' size='small'>Excluir Serviço</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default ModalExcluirServico;